export default String.raw`
{% include 'partials/common/date-format.html' -%}

<div class="eshop__table-container">
    <table>
        <colgroup>
            <col style="width:100px">
            <col style="width:150px">
            <col style="width:250px">
        </colgroup>
        <thead>
            <tr>
                <th class="id">{{ translations.Date }}</th>
                <th>{{ translations.Hour }}</th>
                <th>{{ translations.Action }}</th>
                <th>{{ translations.Operator }}</th>   
            </tr>
        </thead>
        <tbody>
        {% for item in customer-profile.History.Items -%}
            <tr>
                <td class="id">{{ item.Date | Date:dateFormat }}</td>
                <td>{{ item.Date | Date:'HH:mm:ss' }}</td>
                <td>{{ item.Event }}</td>
                <td>{{ item.User }}</td>
            </tr>
        {% endfor -%}
        </tbody>
    </table>
</div>

{% include 'partials/common/pagination.html' -%}
`